import { bootstrapApplication } from '@angular/platform-browser';
import '@angular/common/locales/global/hu';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { client } from './backend/main/client.gen';
import { client as fileClient } from './backend/file/client.gen';
import { environment } from './environment';
import 'zone.js';

client.setConfig({
  baseUrl: environment.apiUrl,
});

fileClient.setConfig({
  baseUrl: `${environment.apiUrl}/files`,
});

bootstrapApplication(App, appConfig).catch(err => console.error(err));
